import React from 'react';
import PropTypes from 'prop-types';
import { Cross } from '../../assets';
import styles from './transactionDetailModal.module.css';

export const TransactionDetailModal = ({
  body,
  tittle,
  onButtonClick
}) => {

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <div className={styles.title} >{tittle}</div>
        <span><img className={styles.imageStyle} src={Cross} onClick={onButtonClick(null)} alt='crossIcon' /></span>
        <div>{body}</div>
      </div>
    </div>
  );
};

TransactionDetailModal.propTypes = {
  tittle: PropTypes.string,
  onButtonClick: PropTypes.func,
  body: PropTypes.object
};
